import { render, staticRenderFns } from "./ViewReport.vue?vue&type=template&id=0cfdd587&scoped=true"
import script from "./ViewReport.vue?vue&type=script&lang=ts"
export * from "./ViewReport.vue?vue&type=script&lang=ts"
import style0 from "./ViewReport.vue?vue&type=style&index=0&id=0cfdd587&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfdd587",
  null
  
)

export default component.exports